import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {Company} from 'src/services/api'
import {PatchDaysToRetainCompany} from 'src/services/api/endpoints/CompanyEndpoint'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdateDaysToRetainOnCompany() {
  const {enqueueSnackbar} = useSnackbar()

  const mutation = useMutation({
    mutationFn: async ({id, body}: {id: number; body: Company}) => {
      const patch = new PatchDaysToRetainCompany(id, body)
      await api.company.updateDaysToRetain(patch)
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos atualizar a empresa no momento')
    },
  })
  return mutation
}
